import type { StyleSpecification } from "mapbox-gl";

/** Minimal basemap with no network tile requests — used when offline. */
export const OFFLINE_MAP_STYLE: StyleSpecification = {
  version: 8,
  name: "ruumi-offline",
  sources: {},
  layers: [
    {
      id: "background",
      type: "background",
      paint: {
        "background-color": "#e8e4dc",
      },
    },
  ],
};

export const ONLINE_MAP_STYLE = "mapbox://styles/mapbox/satellite-streets-v12";

/** Solid field polygons (no satellite overlay) on mobile and when offline. */
export function shouldUseSolidFieldFills(
  isMobile: boolean,
  online: boolean
): boolean {
  return isMobile || !online;
}

export function getMapStyleForConnectivity(
  online: boolean
): string | StyleSpecification {
  return online ? ONLINE_MAP_STYLE : OFFLINE_MAP_STYLE;
}
